/**
 * Retrieves the unread messages count and updates the messages icon
 *
 * @author    Learning Technologies <learning-technologies@abdn.ac.uk>
 * @version   16-Nov-2016
 * @copyright University of Aberdeen
 */

// Check the messages when the page loads
$(document).ready(function () {
    if ($('#announcements').length > 0) {
        userAnnouncementsUnread();
    }
});

// Check the messages when the page is redisplayed (e.g. moved from another browser tab to this one)
$(document).focus(function () {
    if ($('#announcements').length > 0) {
        userAnnouncementsUnread();
    }
});

// Loads the confirmation delete modal when admins wish to delete/unpublish announcements
$('#deleteAnnouncementModal').on('show.bs.modal', function (e) {
    var announcement = e.relatedTarget;
    var deleteAnnouncmentModal = $(this);
    var id = $(announcement).data('id');
    var title = $(announcement).data('title');

    $(deleteAnnouncmentModal).find('.message-title').text(title);
    $(deleteAnnouncmentModal).find('input[type="hidden"][name="id"]').val(id);
});

/**
 * Retrieves an unread announcements count
 *
 * @returns void
 */
function userAnnouncementsUnread() {
    // Show the loading icons
    loadingIcon();

    // Process the ajax request
    $.ajax({
        type: 'GET',
        url: getUnreadUrl,
        dataType: 'json',
    })
        .done(function (data) {
            if (data.status === 200) {
            // Request successful
                if (data.announcementsCount > 0) {
                // There are unread messages - display the count and change the icon
                    unreadIcon(data.announcementsCount);
                } else {
                // All messages have been read
                    allReadIcon();
                }
            } else {
            // Display error
                errorIcon();
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
        // Display error
            errorIcon();
        });
}

/**
 * Reset icons and add the loading spinner
 *
 * @returns void
 */
function loadingIcon() {
    // Reset the icon and active state
    resetIcons();

    // Add the loading spinner
    $('#announcements a i').addClass('fa-circle-notch fa-spin');

    // Change the title attribute
    $('#announcements a').attr('title', 'Loading unread announcements.');
}

/**
 * Reset icons and signify that there are unread announcements
 *
 * @param announcementsCount The number of unread announcements
 *
 * @returns void
 */
function unreadIcon(announcementsCount) {
    // Reset the icon and active state
    resetIcons();

    // Change the icons to signify that there are unread announcements
    $('#announcements a i').addClass('active');
    $('#announcements a i').addClass('fa-bell');

    // Change the title attribute and set the announcement count text appropriately
    $('#announcements a sup').text(announcementsCount);
    $('#announcements a').attr('title', 'You have ' + announcementsCount + ' unread announcements.');
}

/**
 * Reset icons and signify that there are no unread announcements
 *
 * @returns void
 */
function allReadIcon() {
    // Reset the icon and active state
    resetIcons();

    // Change the icons to signify that there are no unread announcements
    $('#announcements a i').removeClass('fa-solid');
    $('#announcements a i').addClass('fa-regular fa-bell');

    // Change the title attribute and set the announcement count text appropriately
    $('#announcements a sup').text('0');
    $('#announcements a').attr('title', 'You have no unread announcements.');
}

/**
 * Reset icons and signify that there has been an error retrieving the unread announcements
 *
 * @returns void
 */
function errorIcon() {
    // Reset the icon and active state
    resetIcons();

    // Change the icons to signify that there has been an error retrieving the unread announcements
    $('#announcements a i').addClass('fa-regular fa-bell');

    // Change the title attribute and set the announcement count text appropriately
    $('#announcements a sup').text('!');
    $('#announcements a').attr('title', 'Your unread announcements cannot be retrieved at this time.');
}

/**
 * Reset icons
 *
 * @returns void
 */
function resetIcons() {
    // Reset the icon and active state
    $('#announcements a i').removeClass('active');
    $('#announcements a i').removeClass('fa-regular fa-bell');
    $('#announcements a i').removeClass('fa-bell');
    $('#announcements a i').removeClass('fa-circle-notch fa-spin');
    $('#announcements a sup').text('');
    $('#announcements a').attr('title', 'Click to view announcements');
}
